import React from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { Button, Typography, Divider, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import SideMenu from '../components/SideMenu';
import TopMenu from '../components/TopMenu';
import { pink, blue, teal, yellow, orange, indigo } from '@mui/material/colors';

function PickingSalesOrderList() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Top menu */}
      <TopMenu />
      {/* Side menu */}
      <SideMenu />

      {/* Main container */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
          marginTop: '64px',
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Box display="flex" gap={2} alignItems="center">
            <Button variant="outlined" startIcon={<ArrowBack />} sx={{ mt: 2, mb: 2, backgroundColor: indigo[500], color: '#fff' }} onClick={() => { navigate(-1)}}>
              Back
            </Button>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }} style={{marginTop: 40}}>
          <Box sx={{ width: '100%' }}>
            {/* Start 70% */}
            <Box>
              <Typography variant="h6" color="primary" fontWeight={600}>Sales Order List</Typography>
              
              <Divider sx={{ mb: 2 }} />
              <TableContainer component={Paper} sx={{ mb: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Order</TableCell>
                      <TableCell>Customer</TableCell>
                      <TableCell>Price Level</TableCell>
                      <TableCell>Last Update Date</TableCell>
                      <TableCell>Sales Person</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Queue Position</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>PM12345</TableCell>
                      <TableCell>Tienda Latina</TableCell>
                      <TableCell>1</TableCell>
                      <TableCell>04/21/2025 9:00</TableCell>
                      <TableCell>AM</TableCell>
                      <TableCell><Chip label="Not started" color="error" /></TableCell>
                      <TableCell>1</TableCell>
                      <TableCell><Button variant='contained' color='primary' size='small'>Open</Button></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>PM12345</TableCell>
                      <TableCell>Supermarket Latino</TableCell>
                      <TableCell>2</TableCell>
                      <TableCell>04/21/2025 9:00</TableCell>
                      <TableCell>JC</TableCell>
                      <TableCell><Chip label="In progress" sx={{ mt: 2, mb: 2, backgroundColor: yellow[500] }} /></TableCell>
                      <TableCell>2</TableCell>
                      <TableCell><Button variant='contained' color='primary' size='small'>Open</Button></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>PM12345</TableCell>
                      <TableCell>Tienda Latina #2</TableCell>
                      <TableCell>1</TableCell>
                      <TableCell>04/21/2025 9:00</TableCell>
                      <TableCell>AS</TableCell>
                      <TableCell><Chip label="Finished" color="success" /></TableCell>
                      <TableCell><Chip label="Completed" color="success" /></TableCell>
                      <TableCell><Button variant='contained' color='primary' size='small'>Open</Button></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PickingSalesOrderList;
